import { RawIntlProvider } from 'react-intl';

import styles from './index.module.less';

import { Card, Col, Logo, Row, Spinner } from '$HVUI';
import { useIntlHelper } from '$Hooks';

const Index = props => {
    let { ourIntl, updateIntl, loading } = useIntlHelper({
        shouldIntl: false
    });

    const content = () => {
        if (loading) {
            return <Spinner size={60} center={true} />;
        }

        return (
            <>
                <h1>Digital Covid-19 Records powered by Healthvana</h1>
                <h2>
                    I scanned this QR code from a digital test result or
                    vaccination record. What is this?
                </h2>
                <p>
                    Healthvana provides patients with continued access to their
                    Covid-19 information. For Covid-19 test results, we display
                    the test type, result status, testing laboratory, and the
                    date of when the test was performed. For Covid-19
                    vaccinations, we display which Covid-19 vaccine was
                    administered and the administration dates for each dose -
                    the same key information on someone’s CDC Covid-19
                    Vaccination Record Card. This information can be accessed
                    through Healthvana’s HIPAA-compliant platform from a phone,
                    computer, or tablet. We also enable patients with the
                    ability to download this information to their devices for
                    convenience through Apple Wallet or Google Pay.
                </p>
                <h2>Who is Healthvana?</h2>
                <p>
                    We are a HIPAA-secure, mobile-friendly platform for patients
                    to manage their health. We've partnered with public health
                    agencies and healthcare providers to help deliver millions
                    of Covid-19 test results to patients across the United
                    States and since December of 2020 we have also been
                    delivering digital vaccination records.
                </p>
                <h2>
                    Where is the information for this digital record coming
                    from?
                </h2>
                <p>
                    Healthvana receives test results and vaccination records
                    directly from testing laboratories and public health /
                    healthcare providers who partner with us to provide patients
                    with a digital version.
                </p>
                <h2>Where might this information be used?</h2>
                <p>
                    It’s up to the patient how their information is used and if
                    they want to show or share their information. Healthvana
                    just provides a digital version of a Covid-19 record that is
                    simple and safe. We empower patients with continued access
                    to their information so they can access and share it as
                    needed.
                </p>
                <h2>
                    How does Healthvana ensure a person has their correct health
                    information?
                </h2>
                <p>
                    Identity verification, including confirmation of full name
                    and DOB, is required in order for an individual to access
                    their digital Covid-19 record and store it in their digital
                    wallet. Healthvana’s privacy and security policies meet the
                    regulations, standards, and guidance set by the Office of
                    Civil Rights under Health and Human Services.
                </p>
                <p>
                    For more information please visit{' '}
                    <a href="https://healthvana.com/faq/">
                        https://healthvana.com/faq/
                    </a>
                    .
                </p>
                <p>
                    To get in touch with us please visit{' '}
                    <a href="https://healthvana.com/contact/">
                        https://healthvana.com/contact/
                    </a>
                    .
                </p>
            </>
        );
    };

    return (
        <RawIntlProvider value={ourIntl}>
            <section className={styles['vaccination']}>
                <main>
                    <Card
                        className={styles['card']}
                        title={
                            <Row>
                                <Col span={12}>
                                    <Logo style={{ width: '100%' }} />
                                </Col>
                                <Col span={12} />
                            </Row>
                        }
                    >
                        {content()}
                    </Card>
                </main>
            </section>
        </RawIntlProvider>
    );
};

export default Index;
